"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadFile = void 0;
const featureToggles_1 = require("@/utils/featureToggles");
const cloud_upload_svg_1 = __importDefault(require("assets/cloud-upload.svg"));
const file_svg_1 = __importDefault(require("assets/file.svg"));
const green_check_svg_1 = __importDefault(require("assets/green-check.svg"));
const warning_svg_1 = __importDefault(require("assets/warning.svg"));
const firebase_app_1 = __importDefault(require("common/firebase-app"));
const firestore_web_1 = require("comodel/firestore-web");
const firestore_1 = require("firebase/firestore");
const storage_1 = require("firebase/storage");
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_hook_form_1 = require("react-hook-form");
const standard_1 = require("react-hook-schema/standard");
const components_1 = require("utils/components");
const helpers_1 = require("../helpers");
const GoogleImport_1 = __importStar(require("./GoogleImport"));
const multiple = false;
const storage = (0, storage_1.getStorage)(firebase_app_1.default);
const firestore = (0, firestore_1.getFirestore)(firebase_app_1.default);
const wait = (time) => new Promise((resolve) => setTimeout(resolve, time));
// エラーメッセージを定数として定義
const ERROR_MESSAGES = {
    FILE_DUPLICATE: "ファイル名が重複しています",
    FILE_DUPLICATE_IN_TRASH: "ゴミ箱にあるファイルと、ファイル名が重複しています",
    FILE_TYPE_INVALID: "ファイルタイプが間違っています",
};
const checkExistFileName = (_a) => __awaiter(void 0, [_a], void 0, function* ({ fileName, rootPath, fieldPath, }) {
    const collectionRef = (0, firestore_1.collection)(firestore, rootPath);
    const queryRef = (0, firestore_1.query)(collectionRef, ...(0, firestore_web_1.getQueryConstraints)({
        filter: { [fieldPath]: fileName },
    }));
    const snapshot = yield (0, firestore_1.getDocs)(queryRef);
    const deleted = snapshot.docs.find((doc) => doc.data().deletedAt);
    return {
        isExist: !snapshot.empty,
        isDeleted: !!deleted,
    };
});
// 重複チェックエラー設定ヘルパー関数
const setDuplicateFileNameError = (setErrors, index, deleted) => {
    setErrors === null || setErrors === void 0 ? void 0 : setErrors((prev) => {
        const next = [...prev];
        next[index] = deleted
            ? ERROR_MESSAGES.FILE_DUPLICATE_IN_TRASH
            : ERROR_MESSAGES.FILE_DUPLICATE;
        return next;
    });
};
const UploadFile = (props) => {
    const { projectId, disposition, onNext } = props;
    const propertyName = "multiFile";
    const fileNameFieldPath = "segmentName";
    const fileFieldPath = "rawFiles";
    const rootPath = `translation_project/${projectId}/segment`;
    const validators = [helpers_1.isValidFileSize, helpers_1.isValidRowSize, helpers_1.isXLSXFile, helpers_1.hasDataRows];
    const accept = ".xlsx";
    const onChange = (value) => {
        setValue(propertyName, value);
    };
    const { register, control, watch, setValue } = (0, react_hook_form_1.useFormContext)();
    const inputRef = (0, react_1.useRef)(null);
    const completedUploadsRef = (0, react_1.useRef)({});
    const toast = (0, standard_1.useToast)();
    const [progress, setProgress] = (0, react_1.useState)({});
    const [dragging, setDragging] = (0, react_1.useState)(false);
    const { append, remove } = (0, react_hook_form_1.useFieldArray)({
        control,
        name: fileFieldPath,
    });
    const [errors, setErrors] = (0, react_1.useState)([]);
    const [googleImport, setGoogleImport] = (0, react_1.useState)(false);
    const values = watch(fileFieldPath);
    const files = watch(fileFieldPath);
    const handleFileUpload = (newFiles) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (!newFiles)
            return;
        if (!multiple && (files === null || files === void 0 ? void 0 : files.length) > 0) {
            toast({
                message: "一度に1つのファイルのみアップロード可能です。既存のファイルを削除してから再度お試しください。",
                duration: 3000,
            });
            return;
        }
        const _newFileArray = Array.from(newFiles);
        const validFiles = [];
        const existingValues = watch(propertyName) || [];
        for (const [_index, file] of _newFileArray.entries()) {
            const index = _index + ((files === null || files === void 0 ? void 0 : files.length) || 0);
            let error = false;
            for (const validator of validators !== null && validators !== void 0 ? validators : []) {
                const result = yield validator(file);
                if (result === null || result === void 0 ? void 0 : result.error) {
                    if (!props.onErrors) {
                        yield toast({
                            message: result.message,
                            duration: 3000,
                        });
                    }
                    (_a = props.onErrors) === null || _a === void 0 ? void 0 : _a.call(props, [result.message]);
                    error = true;
                    continue;
                }
            }
            if (error)
                continue;
            const fileName = file.name.replace(/\.[a-zA-Z0-9]+$/, "") || "";
            const { isExist, isDeleted: deleted } = yield checkExistFileName({
                fileName,
                rootPath,
                fieldPath: fileNameFieldPath || "fileName",
            });
            if (isExist) {
                setDuplicateFileNameError(setErrors, index, deleted);
            }
            validFiles.push({ file, fileName });
        }
        const updatedFiles = [...validFiles];
        append === null || append === void 0 ? void 0 : append(updatedFiles);
        const uploadPromises = validFiles.map((e, _index) => __awaiter(void 0, void 0, void 0, function* () {
            var _c;
            const index = _index + ((files === null || files === void 0 ? void 0 : files.length) || 0);
            const { file, fileName } = e;
            const path = `${rootPath || ""}/${Date.now()}_${_index}`;
            const fileRef = (0, storage_1.ref)(storage, path);
            const contentType = file.type;
            if (accept &&
                accept[0] !== "." &&
                !(contentType === null || contentType === void 0 ? void 0 : contentType.startsWith(accept.replaceAll("*", "")))) {
                const errorMessage = ERROR_MESSAGES.FILE_TYPE_INVALID;
                if (!props.onErrors) {
                    yield toast({
                        message: errorMessage,
                        duration: 10000,
                    });
                }
                (_c = props.onErrors) === null || _c === void 0 ? void 0 : _c.call(props, [errorMessage]);
                setErrors === null || setErrors === void 0 ? void 0 : setErrors((prev) => {
                    const next = [...prev];
                    next[index] = errorMessage;
                    return next;
                });
                return null;
            }
            const encodeRFC5987ValueChars = (str) => {
                return encodeURIComponent(str)
                    .replace(/['()]/g, (match) => "%" + match.charCodeAt(0).toString(16))
                    .replace(/\*/g, "%2A")
                    .replace(/%20/g, " ");
            };
            const task = (0, storage_1.uploadBytesResumable)(fileRef, file, {
                contentType,
                cacheControl: "public, max-age=2592000",
                contentDisposition: `${disposition || "inline"}; filename*=UTF-8''${encodeRFC5987ValueChars(file.name)}`,
            });
            task.on("state_changed", (snapshot) => {
                if (snapshot.state === "running") {
                    const percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    setProgress((prev) => (Object.assign(Object.assign({}, prev), { [file.name]: percent })));
                }
                if (snapshot.state === "error" || snapshot.state === "canceled") {
                    setProgress((prev) => (Object.assign(Object.assign({}, prev), { [file.name]: 0 })));
                }
            });
            try {
                yield task;
                // Mark this file as completed in the ref
                completedUploadsRef.current[file.name] = true;
                const newValue = (0, standard_1.encodeSrc)({
                    protocol: "gs",
                    host: firebase_app_1.default.options.storageBucket,
                    path: `/${path}`,
                    contentType: file.type,
                    name: file.name,
                });
                return newValue;
            }
            catch (_d) {
                return null;
            }
        }));
        const newValues = (_b = (yield Promise.all(uploadPromises))) === null || _b === void 0 ? void 0 : _b.filter((v) => v !== null);
        const updatedValues = [...existingValues, ...newValues];
        onChange(updatedValues);
        yield wait(500);
        toast({
            message: "すべてのファイルのアップロードが完了しました",
            duration: 3000,
            type: "success",
        });
        if (inputRef.current) {
            inputRef.current.value = "";
        }
    });
    const handleRemove = (index) => {
        const fileToRemove = files[index];
        if (fileToRemove) {
            // Remove from completedUploadsRef
            if (completedUploadsRef.current[fileToRemove.file.name]) {
                const updatedCompletedUploads = Object.assign({}, completedUploadsRef.current);
                delete updatedCompletedUploads[fileToRemove.file.name];
                completedUploadsRef.current = updatedCompletedUploads;
            }
        }
        remove(index);
        setErrors((prev) => {
            const next = [...prev];
            next.splice(index, 1);
            return next;
        });
        const currentValues = watch(propertyName) || [];
        const newValues = currentValues.filter((_, i) => i !== index);
        onChange(newValues);
    };
    const validateFileName = (index, fileName) => __awaiter(void 0, void 0, void 0, function* () {
        const file = files === null || files === void 0 ? void 0 : files[index];
        if (!file)
            return;
        if (rootPath) {
            if (!(fileName === null || fileName === void 0 ? void 0 : fileName.trim())) {
                setErrors === null || setErrors === void 0 ? void 0 : setErrors((prev) => {
                    const next = [...prev];
                    next[index] = "ファイル名を入力してください";
                    return next;
                });
                return;
            }
            const { isExist, isDeleted: deleted } = yield checkExistFileName({
                fileName,
                rootPath,
                fieldPath: fileNameFieldPath || "fileName",
            });
            if (isExist) {
                setDuplicateFileNameError(setErrors, index, deleted);
            }
            else {
                setErrors === null || setErrors === void 0 ? void 0 : setErrors((prev) => {
                    const next = [...prev];
                    next[index] = undefined;
                    return next;
                });
            }
        }
    });
    (0, react_1.useEffect)(() => {
        var _a;
        (_a = props.onErrors) === null || _a === void 0 ? void 0 : _a.call(props, errors);
    }, [errors]);
    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false);
        if (!multiple && (files === null || files === void 0 ? void 0 : files.length) > 0) {
            toast({
                message: "一度に1つのファイルのみアップロード可能です。既存のファイルを削除してから再度お試しください。",
                duration: 3000,
            });
            return;
        }
        const droppedFiles = e.dataTransfer.files;
        if (!multiple && droppedFiles.length > 1) {
            const singleFileList = new DataTransfer();
            singleFileList.items.add(droppedFiles[0]);
            handleFileUpload(singleFileList.files);
        }
        else {
            handleFileUpload(droppedFiles);
        }
    };
    const uploadMode = watch("uploadMode");
    const handleNext = () => {
        if (errors === null || errors === void 0 ? void 0 : errors.some((e) => !!e)) {
            return;
        }
        if (!uploadMode) {
            onNext({ error: "アップロードモードを選択してください" });
            return;
        }
        if ((!files || files.length == 0) && (!values || values.length === 0)) {
            onNext({ error: "ファイルをアップロードしてください" });
            return;
        }
        onNext({ error: "" });
    };
    // Google Import
    const { setImportTask, progress: googleProgress } = (0, GoogleImport_1.useGoogleImport)({
        control,
        fileFieldPath: "rawFiles",
        nameFieldPath: "segmentName",
        onError: (error) => setErrors([error]),
    });
    const handleCloseGoogleImport = () => {
        setGoogleImport(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.Card, { title: "\u30C7\u30FC\u30BF\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9", tooltip: "\u7FFB\u8A33\u5BFE\u8C61\u306E\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002" },
            react_1.default.createElement("div", { style: { padding: "30px 36px" } },
                react_1.default.createElement("div", { onDragOver: !multiple && (files === null || files === void 0 ? void 0 : files.length) > 0
                        ? undefined
                        : (e) => {
                            e.preventDefault();
                            setDragging(true);
                        }, onDragLeave: () => setDragging(false), onDrop: !multiple && (files === null || files === void 0 ? void 0 : files.length) > 0 ? undefined : handleDrop, className: "border-pr", style: {
                        border: "2px dashed #94A3B8",
                        borderColor: dragging ? "#2d73b9" : "#ccc",
                        borderRadius: "4px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "between",
                        alignItems: "center",
                        height: 210,
                        transition: "border 0.3s ease",
                        backgroundColor: (!multiple && (files === null || files === void 0 ? void 0 : files.length) > 0) || googleImport
                            ? "#F4F4F4"
                            : "#F0F9FF",
                        opacity: !multiple && (files === null || files === void 0 ? void 0 : files.length) > 0 ? 0.6 : 1,
                        cursor: !multiple && (files === null || files === void 0 ? void 0 : files.length) > 0 ? "not-allowed" : "default",
                    } },
                    react_1.default.createElement("div", { style: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            marginTop: 48,
                            flex: 1,
                        } },
                        react_1.default.createElement("img", { src: cloud_upload_svg_1.default, alt: "cloud-upload" }),
                        react_1.default.createElement("p", { style: { color: "#BABAC6", fontSize: 20, fontWeight: 700 } }, "\u30C9\u30E9\u30C3\u30B0&\u30C9\u30ED\u30C3\u30D7"),
                        !multiple && (files === null || files === void 0 ? void 0 : files.length) > 0 && (react_1.default.createElement("p", { style: { color: "#94A3B8", fontSize: 14, marginTop: 4 } }, "\u203B\u30D5\u30A1\u30A4\u30EB\u3092\u8FFD\u52A0\u3059\u308B\u306B\u306F\u3001\u65E2\u5B58\u306E\u30D5\u30A1\u30A4\u30EB\u3092\u524A\u9664\u3057\u3066\u304F\u3060\u3055\u3044"))),
                    react_1.default.createElement("div", { style: { display: "flex", gap: 22, marginBottom: 16 } },
                        react_1.default.createElement(components_1.Button, { style: { width: 360, position: "relative" }, variant: googleImport ? "secondary" : "info", disabled: googleImport || (!multiple && (files === null || files === void 0 ? void 0 : files.length) > 0) },
                            "\u30D5\u30A1\u30A4\u30EB\u9078\u629E",
                            react_1.default.createElement("input", Object.assign({}, (accept ? { accept } : undefined), { type: "file", multiple: multiple, style: {
                                    position: "absolute",
                                    top: 0,
                                    bottom: 0,
                                    right: 0,
                                    left: 0,
                                    opacity: 0,
                                    cursor: !multiple && (files === null || files === void 0 ? void 0 : files.length) > 0
                                        ? "not-allowed"
                                        : "pointer",
                                }, ref: inputRef, onChange: (e) => handleFileUpload(e.target.files), disabled: !multiple && (files === null || files === void 0 ? void 0 : files.length) > 0 }))),
                        featureToggles_1.featureToggle.importSpreadSheet && (react_1.default.createElement(components_1.Button, { onClick: () => setGoogleImport((prev) => !prev), variant: googleImport ? "secondary" : "info", style: { width: 360 }, disabled: googleImport }, "Google \u30B9\u30D7\u30EC\u30C3\u30C9\u30B7\u30FC\u30C8\u304B\u3089\u30A4\u30F3\u30DD\u30FC\u30C8")))),
                googleImport && (react_1.default.createElement("div", { style: { marginTop: 40 } },
                    react_1.default.createElement(GoogleImport_1.default
                    // disabled={googleProgress?.status === "importing"}
                    , { 
                        // disabled={googleProgress?.status === "importing"}
                        onSubmit: ({ url }) => {
                            setImportTask({ url });
                        }, onClose: handleCloseGoogleImport }))))), files === null || files === void 0 ? void 0 :
        files
        // ?.filter((file) => !file?.source)
        .map((file, index) => {
            const isCompleted = completedUploadsRef.current[file.file.name] === true;
            let displayProgress;
            if (progress[file.file.name] !== undefined) {
                displayProgress = progress[file.file.name];
            }
            else if (isCompleted) {
                displayProgress = 100;
            }
            else {
                displayProgress = 100;
            }
            if ((file === null || file === void 0 ? void 0 : file.source) === "googleImport" &&
                (googleProgress === null || googleProgress === void 0 ? void 0 : googleProgress.status) === "imported") {
                displayProgress = 100;
            }
            else if ((googleProgress === null || googleProgress === void 0 ? void 0 : googleProgress.status) === "importing") {
                displayProgress = 80;
            }
            return (react_1.default.createElement(components_1.Card, { key: index },
                react_1.default.createElement("div", { className: "", style: {
                        display: "flex",
                        justifyContent: "between",
                        alignItems: "center",
                        padding: "30px 20px",
                        paddingRight: "20px",
                        gap: "20px",
                    } },
                    react_1.default.createElement("img", { src: file_svg_1.default, alt: "file" }),
                    react_1.default.createElement("div", { style: { width: "100%" } },
                        react_1.default.createElement("p", { style: {
                                fontSize: "12px",
                            } }, file.file.name),
                        react_1.default.createElement(react_bootstrap_1.ProgressBar, { now: displayProgress, variant: (errors === null || errors === void 0 ? void 0 : errors[index]) ? "danger" : "success", style: {
                                height: 8,
                                width: "100%",
                                background: "#D9D9D9",
                                transition: "width 0.5s ease-in-out",
                            } }),
                        react_1.default.createElement("div", { style: { minHeight: 18 } },
                            displayProgress === 100 && (react_1.default.createElement("p", { style: {
                                    color: !(errors === null || errors === void 0 ? void 0 : errors[index]) ? "#49C67D" : "#DC2626",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                } }, "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002")),
                            displayProgress < 100 && (react_1.default.createElement("p", { style: {
                                    color: "#767676",
                                    fontSize: "12px",
                                } },
                                displayProgress || 0,
                                "% ... loading")),
                            (googleProgress === null || googleProgress === void 0 ? void 0 : googleProgress.status) === "importing" && (react_1.default.createElement("p", { style: {
                                    color: "#767676",
                                    fontSize: "12px",
                                } }, "importing...")))),
                    (errors === null || errors === void 0 ? void 0 : errors[index]) ? (react_1.default.createElement("img", { src: warning_svg_1.default, alt: "warning" })) : (react_1.default.createElement("img", { src: green_check_svg_1.default, alt: "check" }))),
                react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-between gap-3", style: {
                        padding: "20px",
                        borderTop: "1px solid #D4D4D4",
                    } },
                    react_1.default.createElement("div", { className: "d-flex align-items-center w-100 gap-3" },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, { style: {
                                whiteSpace: "nowrap",
                                fontWeight: 700,
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                marginBottom: 0,
                            } },
                            react_1.default.createElement("span", null, "\u30D5\u30A1\u30A4\u30EB\u540D"),
                            " ",
                            react_1.default.createElement(components_1.Button, { variant: "primary", "data-tooltip-id": "tooltip", "data-tooltip-html": true &&
                                    `<div class="tooltip-content">${file.file.name}</div>`, style: {
                                    borderRadius: "50%",
                                    width: "16px",
                                    height: "16px",
                                    padding: "0",
                                    flexShrink: 0,
                                } },
                                react_1.default.createElement("span", { className: "mdi mdi-information-variant size10" }))),
                        react_1.default.createElement(react_bootstrap_1.Form.Control, Object.assign({ type: "text" }, register(`${fileFieldPath}.${index}.fileName`, {
                            onChange: (e) => {
                                validateFileName(index, e.target.value);
                            },
                            onBlur: (e) => {
                                validateFileName(index, e.target.value);
                            },
                        }), { isInvalid: !!(errors === null || errors === void 0 ? void 0 : errors[index]) })),
                        (errors === null || errors === void 0 ? void 0 : errors[index]) && (react_1.default.createElement(react_bootstrap_1.Form.Control.Feedback, { type: "invalid" }, errors === null || errors === void 0 ? void 0 : errors[index]))),
                    react_1.default.createElement("div", { className: "d-flex align-items-center" },
                        react_1.default.createElement("button", { type: "button", onClick: () => handleRemove(index), style: {
                                border: "none",
                                background: "none",
                                cursor: "pointer",
                            } },
                            react_1.default.createElement("i", { className: "mdi mdi-trash-can-outline", style: { fontSize: 24 } }))))));
        }),
        (googleProgress === null || googleProgress === void 0 ? void 0 : googleProgress.status) === "importing" && (react_1.default.createElement(components_1.Card, null,
            react_1.default.createElement("div", { style: {
                    display: "flex",
                    justifyContent: "between",
                    alignItems: "center",
                    padding: "30px 20px",
                    paddingRight: "20px",
                    gap: "20px",
                } },
                react_1.default.createElement("img", { src: file_svg_1.default, alt: "file" }),
                react_1.default.createElement("div", { style: { width: "100%" } },
                    react_1.default.createElement("p", { style: {
                            fontSize: "12px",
                        } }, "0%... loading"),
                    react_1.default.createElement(react_bootstrap_1.ProgressBar, { now: 0, variant: "success", style: {
                            height: 8,
                            width: "100%",
                            background: "#D9D9D9",
                        } }),
                    react_1.default.createElement("div", { style: { minHeight: 18 } }, (googleProgress === null || googleProgress === void 0 ? void 0 : googleProgress.status) === "importing" && (react_1.default.createElement("p", { style: {
                            color: "#767676",
                            fontSize: "12px",
                        } }, "0%... loading"))))))),
        react_1.default.createElement("div", { className: "d-flex justify-content-end" },
            react_1.default.createElement(components_1.Button, { style: { width: 150 }, onClick: handleNext, size: "xl", disabled: errors.filter((e) => !!e).length > 0 || (files === null || files === void 0 ? void 0 : files.length) === 0 }, "\u6B21\u3078"))));
};
exports.UploadFile = UploadFile;
// @todo validation
